import { useTranslation } from "react-i18next";

const COLOURS: Record<string, string> = {
  transcription: "bg-blue-50 dark:bg-blue-950 text-blue-700 dark:text-blue-300",
  project: "bg-purple-50 dark:bg-purple-950 text-purple-700 dark:text-purple-300",
  extraction: "bg-emerald-50 dark:bg-emerald-950 text-emerald-700 dark:text-emerald-300",
};

/** A recipe's input mode. An unknown mode shows nothing: a guess here once saved an extraction recipe as a transcription one. */
export function RecipeModeBadge({ mode }: { mode: string | undefined }) {
  const { t } = useTranslation();
  if (!mode || !COLOURS[mode]) return null;
  return <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full ${COLOURS[mode]}`}>{t(`naraShape.templateInputMode.${mode}`)}</span>;
}
